<template>

    <section class="pb-8 bg-white lg:pb-16" id="the-products">
        <div class="max-w-screen-xl px-4 mx-auto lg:md:px-4">

            <div class="mx-auto ">
                <h3 class="mb-6 text-3xl text-center md:text-4xl font-ww-bold text-balance xl:!leading-none xl:text-42  max-w-4xl mx-auto xl:px-12">
                    {{ title }}
                </h3>

                <div class="text-2xl text-center xl:text-3xl font-ww-medium">
                     {{ shippingText }}
                </div>
                <div class="grid grid-cols-12 mt-6 lg:mt-20 gap-x-4 xl:gap-x-8" v-if="state.items[state.active.items]">
                    <div class="col-span-12 md:px-4 lg:col-span-6 lg:px-0">

                        <SwiperProductCallery :productImages="processedProductImages" :productImageAlt="productImageAlt" />

                        <div class="items-center justify-center hidden mt-4 md:mt-10 gap-x-4 md:flex">
                            <nuxt-img :src="logoSrc" loading="lazy" class="" width="96" height="103" :alt="logoAlt"/>

                            <a href="https://www.bbb.org/us/in/carmel/profile/coffee-and-tea/lifeboost-coffee-0382-90017189/#sealclick" class="p-0.5 bg-white border border-black rounded-lg h-fit" target="_blank" rel="nofollow"><nuxt-img loading="lazy" width="200" height="65" src="https://seal-indy.bbb.org/seals/blue-seal-200-65-bbb-90017189.png" style="border: 0;" alt="Lifeboost Coffee BBB Business Review"/></a>
                        </div>


                    </div>
                    <div class="col-span-12 lg:col-span-6">
                        <h3 class="text-2xl text-center xl:text-3xl font-ww-bold lg:text-left">
                            {{ productTitle }}
                        </h3>
                        <div class="flex items-center justify-center my-4 lg:justify-start">
                            <nuxt-img sizes="xs:330px sm:440px md:760px lg:1024px xl:1200x 2xl:1400px" loading="lazy"
                                format="webp" width="120" height="24" :src="starsImageSrc"
                                :alt="starsImageAlt" class="w-24 lg:w-30" />
                            <span class="ml-2 text-[#3B3B3B] font-ww-regular text-base">
                         

                         

                                <strong>{{ currentRating?.avg_rating }}/5</strong> {{ fromText }} <strong>{{ currentRating?.reviews_count }}</strong> {{ reviewsText }}
                            </span>
                        </div>

                        <div class="text-base md:text-lg font-ww-regular text-[#7B7B7B] italic !leading-6 text-left" v-html="customerReview">
                        </div>

                        <div class="mt-4 text-base md:text-lg font-ww-regular !leading-6 text-left" v-html="productDescription">
                        </div>

                        <!-- <div class="flex items-center justify-center gap-x-2">
                            <div class="md:text-2xl text-xl font-bold font-ww-medium text-[#3B3B3B]">
                                ${{ helpers.calculatePriceTimesPack(FilteredPacks[state.active.packs].Price, FilteredPacks[state.active.packs].PackSize) }}

                            </div>

                            <span class="text-[#3B3B3B] line-through text-base pt-1">
                                ${{ helpers.calculatePriceTimesPack(FilteredPacks[state.active.packs].SaleRibbon, FilteredPacks[state.active.packs].PackSize) }}
                            </span>
                        </div> -->

                   

                        <div class="w-full lg:pt-6" id="first-class-swatch">
                            <div class="max-w-2xl mx-auto counter-reset parent-element xl:max-w-3xl">
                             
                                <div class="counter-increment " v-if="Object.keys(state.variants).length > 1">
                                    <div
                                        class="flex flex-wrap justify-center py-3 pt-4 mb-2 text-xl lg:justify-start lg:text-xl font-ww-bold lg:pt-3">
                                        {{ coffeeFormQuestion }}</div>
                                    <div
                                        class="grid lg:grid-cols-3 gap-x-4 gap-y-4 sm:grid-cols-3 sm:gap-y-6 sm:max-w-full">
                                        <!--[-->
                                        <label v-for="(variant, index) in state.variants" @click="setType(index)" :data-testid="'step2-choice-'+index"
                                            role="button" :tabindex="index" :key="index"
                                            :class="state.active.variants == index ? 'border-[#299479] bg-[#F7FEF8] border' : 'bg-[#F2F2F2] border border-[#9CA3AF]'"
                                            class="relative p-4 px-4 py-2 duration-300 ease-out rounded-lg cursor-pointer md:px-4 md:py-2.5 hover:scale-105">
                                          

                                            <svg xmlns="http://www.w3.org/2000/svg" class="absolute top-0 left-1/2 transform -translate-x-1/2 -mt-2.5 w-5 h-auto transition-opacity" v-if="state.active.variants == index" width="20" height="21" viewBox="0 0 20 21" fill="none">
<circle cx="10" cy="10.4082" r="10" fill="#299479"/>
<path d="M8.55425 13.3813L5.91536 10.7424C5.80425 10.6313 5.80425 10.4368 5.91536 10.298L6.33203 9.88129C6.44314 9.77018 6.63759 9.77018 6.77648 9.88129L8.77648 11.8813L13.2209 7.43685C13.332 7.32574 13.5265 7.32574 13.6654 7.43685L14.082 7.85352C14.1931 7.96463 14.1931 8.15907 14.082 8.29796L8.9987 13.3813C8.85981 13.4924 8.66536 13.4924 8.55425 13.3813Z" fill="white"/>
</svg>

                                            <p class="text-lg text-center font-ww-regular">{{  variant.Name }}</p>
                                        </label>
                                    </div>
                                </div>

                                <div class="mt-4 counter-increment" v-if="Object.keys(FilteredPacks).length > 1">
                                    <div
                                        class="flex flex-wrap justify-center py-3 pt-4 mb-2 text-xl lg:text-xl lg:justify-start font-ww-bold lg:pt-3">
                                        {{ quantityQuestion }}</div>
                                    <div
                                        class="grid grid-cols-1 gap-2 md:gap-4 md-max:gap-y-8 sm-max:gap-x-4 sm:grid-cols-2 lg:gap-4 xl:gap-6 gap-y-4 sm:max-w-full">

                                        <label v-for="(pack, index) in FilteredPacks.slice(0, 2)" @click="setPack(index)" role="button" tabindex="0" :data-testid="'step3-choice-'+index"
                                        :class="state.active.packs == index ? 'border-[#299479] bg-[#F7FEF8] border' : 'bg-[#F2F2F2] border border-[#9CA3AF]'"
                                            class="relative font-medium duration-300 ease-out rounded-lg cursor-pointer hover:scale-105">

                                            <svg xmlns="http://www.w3.org/2000/svg" class="absolute top-0 left-1/2 transform -translate-x-1/2 -mt-2.5 w-5 h-auto transition-opacity" v-if="state.active.packs == index" width="20" height="21" viewBox="0 0 20 21" fill="none">
<circle cx="10" cy="10.4082" r="10" fill="#299479"/>
<path d="M8.55425 13.3813L5.91536 10.7424C5.80425 10.6313 5.80425 10.4368 5.91536 10.298L6.33203 9.88129C6.44314 9.77018 6.63759 9.77018 6.77648 9.88129L8.77648 11.8813L13.2209 7.43685C13.332 7.32574 13.5265 7.32574 13.6654 7.43685L14.082 7.85352C14.1931 7.96463 14.1931 8.15907 14.082 8.29796L8.9987 13.3813C8.85981 13.4924 8.66536 13.4924 8.55425 13.3813Z" fill="white"/>
</svg>

                                          

                                          <div class="flex flex-col pt-3 md:pt-7">                  

                                         <div>
                                          <div class="h-full text-lg leading-5 text-center xl:text-xl font-ww-bold">
                                                {{ pack.Name }}
                                            </div>

                                            <div class="h-36">
                                                <nuxt-img :src="pack.Image.url" :alt="pack.Image.alt" sizes="xs:200px sm:200px md:200px lg:200px xl:200px" format="webp" loading="lazy" width="200" height="144" alt="product" class="object-cover mx-auto" />
                                            </div>
                                         </div>

                                          <div>
                                            <div class="text-sm text-center font-ww-regular">
                                                {{ customerSpecialText }}
                                            </div>

                                            <p v-if="pack.Offer" class="mt-4 text-lg leading-none text-center font-ww-light"
                                            :class="/\d/.test(pack.Offer) && 'line-through'">
                                               {{ pack.Offer }}</p>

                                            <div class="pb-1 text-center md:pb-2">
                                               <span class="text-3xl !leading-none xl:text-2xl lg:text-3xl font-ww-bold"> {{ pack.Price }}</span> <span class="text-xl font-ww-regular">{{ perBagText }}</span>
                                            </div>


                                            <div class="mb-3 text-sm text-center md:mb-6 font-ww-regular">
                                                {{ freeShippingText }}
                                            </div>

                                          
                                      
                                            <div class="py-2 text-sm leading-none text-center text-white rounded-b-lg font-ww-light"  :class="state.active.packs == index ? 'bg-[#299479]' : 'bg-[#887D7C]'">
                                               <span class="text-sm leading-none uppercase md:text-base font-ww-bold"> {{ pack.SaleRibbon }}</span>  <br>    <span class="text-base leading-none md:text-lg font-ww-bold"> {{ saveText }} {{ pack.Discount }} </span>
                                               </div>
                                          </div>
                                          </div>

                                            
                                        </label>
                                    </div>
                                </div>

                     

                            </div>
                            <div class="pt-12 mx-auto text-center lg:text-left">
                                <button @click="addToCart" data-testid="cta-button"
                                    class="relative w-full py-3.5 text-lg md:text-xl lg:max-w-full max-w-2xl cursor-pointer btn-red whitespace-nowrap font-ww-medium"
                                    style=""> {{ buttonText }} </button>
                            </div>

                            <div class="flex mt-6 text-base text-left justify-center font-ww-light xs-max:w-full gap-x-6"><span>✓ 30-Day Money-Back Guarantee</span> <span>✓ Free Shipping</span></div>

                            <div class="flex items-center justify-center mt-4 md:mt-10 gap-x-4 md:hidden">
                            <nuxt-img :src="logoSrc" loading="lazy" class="" width="96" height="103" :alt="logoAlt"/>

                            <a href="https://www.bbb.org/us/in/carmel/profile/coffee-and-tea/lifeboost-coffee-0382-90017189/#sealclick" class="p-0.5 bg-white border border-black rounded-lg h-fit" target="_blank" rel="nofollow"><nuxt-img loading="lazy" width="200" height="65" src="https://seal-indy.bbb.org/seals/blue-seal-200-65-bbb-90017189.png" style="border: 0;" alt="Lifeboost Coffee BBB Business Review"/></a>
                        </div>

                     
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <ModalsCore :modal="modal" :state="state" @set-choice="setChoice" />
    </section>

</template>

<script setup>
import SwiperProductCallery from '../../section/SwiperProductCallery.vue';

// Props for dynamic content
const props = defineProps({
  title: {
    type: String,
    default: '2025 Spring Special Offer (Ends Soon) Get 47% Off Your Order Today',
  },
  shippingText: {
    type: String,
    default: '(We\'ll Even Pay for the Shipping)',
  },
  productTitle: {
    type: String,
    default: 'USDA Organic, Full Flavor Decaf',
  },
  starsImageSrc: {
    type: String,
    default: '/assets/images/stars-swatches.png',
  },
  starsImageAlt: {
    type: String,
    default: 'stars',
  },
  logoSrc: {
    type: String,
    default: '/assets/images/rating-logo-1.png',
  },
  logoAlt: {
    type: String,
    default: 'Decaf Coffee',
  },
  productImages: {
    type: Array,
    default: () => [
      '/assets/images/decaf-img-1.webp',
      '/assets/images/decaf-img-2.webp',
      '/assets/images/decaf-img-3.webp',
      '/assets/images/decaf-img-4.webp',
      '/assets/images/decaf-img-5.webp',
      '/assets/images/decaf-img-6.webp',
      '/assets/images/decaf-img-7.webp',
      '/assets/images/decaf-img-8.webp',
      '/assets/images/decaf-img-9.webp',
      '/assets/images/decaf-img-10.webp',
    ]
  },
  productImageAlt: {
    type: String,
    default: 'Product Image',
  },
  fromText: {
    type: String,
    default: 'from',
  },
  reviewsText: {
    type: String,
    default: 'reviews',
  },
  customerReview: {
    type: String,
    default: '"Good medium decaffeinated bean coffee. Does not upset my stomach from acid and has a nice flavor to it. I can even drink it black which I prefer to do." --Roger H., USA',
  },
  productDescription: {
    type: String,
    default: 'Enjoy delicious, gut-friendly, full flavor coffee decaffeinated without harmful chemicals.',
  },
  coffeeFormQuestion: {
    type: String,
    default: 'Select Coffee Type',
  },
  quantityQuestion: {
    type: String,
    default: 'Select Quantity',
  },
  customerSpecialText: {
    type: String,
    default: 'New Customer Special',
  },
  perBagText: {
    type: String,
    default: '/bag',
  },
  freeShippingText: {
    type: String,
    default: 'Free shipping',
  },
  saveText: {
    type: String,
    default: 'Save',
  },
  offRetailText: {
    type: String,
    default: 'off Retail Price',
  },
  buttonText: {
    type: String,
    default: 'Add to Cart',
  },
  page: {
    type: String,
    default: 'decaf',
  },
});

// Transform productImages if needed (for Builder.io compatibility)
const processedProductImages = computed(() => {
  // Check if the items are objects with a value property (from Builder.io)
  if (props.productImages.length > 0 && typeof props.productImages[0] === 'object' && 'value' in props.productImages[0]) {
    return props.productImages.map(item => item.value);
  }
  // If they're already strings, use them as is
  return props.productImages;
});

defineBuilderComponent({
    friendlyName: 'SwatchesWithSwiper',
    inputs: [
      {
        name: 'title',
        type: 'richText',
        friendlyName: 'Section Title',
        defaultValue: '2025 Spring Special Offer (Ends Soon) Get 47% Off Your Order Today',
      },
      {
        name: 'shippingText',
        type: 'text',
        friendlyName: 'Shipping Text',
        defaultValue: '(We\'ll Even Pay for the Shipping)',
      },
      {
        name: 'productTitle',
        type: 'text',
        friendlyName: 'Product Title',
        defaultValue: 'USDA Organic, Full Flavor Decaf',
      },
      {
        name: 'starsImageSrc',
        type: 'file',
        friendlyName: 'Stars Image Source',
        allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'svg'],
        defaultValue: '/assets/images/stars-swatches.png',
      },
      {
        name: 'starsImageAlt',
        type: 'text',
        friendlyName: 'Stars Image Alt Text',
        defaultValue: 'stars',
      },
      {
        name: 'logoSrc',
        type: 'file',
        friendlyName: 'Logo Image Source',
        allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'svg'],
        defaultValue: '/assets/images/rating-logo-1.png',
      },
      {
        name: 'logoAlt',
        type: 'text',
        friendlyName: 'Logo Alt Text',
        defaultValue: 'Decaf Coffee',
      },
      {
        name: 'productImages',
        type: 'list',
        friendlyName: 'Product Images',
        defaultValue: [
          {
            value: '/assets/images/decaf-img-1.webp'
          },
          {
            value: '/assets/images/decaf-img-2.webp'
          },
          {
            value: '/assets/images/decaf-img-3.webp'
          },
          {
            value: '/assets/images/decaf-img-4.webp'
          },
          {
            value: '/assets/images/decaf-img-5.webp'
          },
          {
            value: '/assets/images/decaf-img-6.webp'
          },
          {
            value: '/assets/images/decaf-img-7.webp'
          },
          {
            value: '/assets/images/decaf-img-8.webp'
          },
          {
            value: '/assets/images/decaf-img-9.webp'
          },
          {
            value: '/assets/images/decaf-img-10.webp'
          }
        ],
        subFields: [
          {
            name: 'value',
            type: 'file',
            friendlyName: 'Image',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp']
          }
        ]
      },
      {
        name: 'productImageAlt',
        type: 'text',
        friendlyName: 'Product Image Alt Text',
        defaultValue: 'Product Image',
      },
      {
        name: 'fromText',
        type: 'text',
        friendlyName: 'From Text',
        defaultValue: 'from',
      },
      {
        name: 'reviewsText',
        type: 'text',
        friendlyName: 'Reviews Text',
        defaultValue: 'reviews',
      },
      {
        name: 'customerReview',
        type: 'richText',
        friendlyName: 'Customer Review',
        defaultValue: '"Good medium decaffeinated bean coffee. Does not upset my stomach from acid and has a nice flavor to it. I can even drink it black which I prefer to do." --Roger H., USA',
      },
      {
        name: 'productDescription',
        type: 'richText',
        friendlyName: 'Product Description',
        defaultValue: 'Enjoy delicious, gut-friendly, full flavor coffee decaffeinated without harmful chemicals.',
      },
      {
        name: 'coffeeFormQuestion',
        type: 'text',
        friendlyName: 'Coffee Form Question',
        defaultValue: 'Select Coffee Type',
      },
      {
        name: 'quantityQuestion',
        type: 'text',
        friendlyName: 'Quantity Question',
        defaultValue: 'Select Quantity',
      },
      {
        name: 'customerSpecialText',
        type: 'text',
        friendlyName: 'Customer Special Text',
        defaultValue: 'New Customer Special',
      },
      {
        name: 'perBagText',
        type: 'text',
        friendlyName: 'Per Bag Text',
        defaultValue: '/bag',
      },
      {
        name: 'freeShippingText',
        type: 'text',
        friendlyName: 'Free Shipping Text',
        defaultValue: 'Free shipping',
      },
      {
        name: 'saveText',
        type: 'text',
        friendlyName: 'Save Text',
        defaultValue: 'Save',
      },
      {
        name: 'offRetailText',
        type: 'text',
        friendlyName: 'Off Retail Text',
        defaultValue: 'off Retail Price',
      },
      {
        name: 'buttonText',
        type: 'text',
        friendlyName: 'Button Text',
        defaultValue: 'Add to Cart',
      },
      {
        name: 'page',
        type: 'text',
        friendlyName: 'Page Type',
        defaultValue: 'decaf',
      },
    ],
});

const { fetchRatingReview } = useReviews()
const currentRating = ref(null)
// Initialize composables
const { 
  state, 
  initializePage,
  FilteredPacks,
  setPack,
  setType,
  runEngine,
} = useSwatches()

const { 
  modal,
  setChoice,
  addToCart
} = useSwatchesCart(runEngine, state)

initializePage(props.page)

// Compute product ID and handle
const productId = computed(() => 
  state.items[state.active.items]?.ExtraData?.reviews?.id || "6639899312188"
)
const handle = computed(() => 
  state.items[state.active.items]?.ExtraData?.reviews?.handle || "single-origin-medium-roast-decaf-coffee"
)

// Watch for changes in product selection
watch(
  [productId, handle],
  async ([newProductId, newHandle]) => {
    currentRating.value = await fetchRatingReview(newProductId, newHandle)
  },
  { immediate: true }
)
</script>

<style scoped>
.swiper-pagination-bullet-active {
    background: #ef4444 !important;
}

.swiper-pagination-bullet {
    background: white;
    opacity: 1;
}

/* .counter-reset .counter-increment {
  position: relative;
  padding-left: 45px;
} */

.parent-element {
    counter-reset: section 0;
    /* Start counting from 1 */
}


/* label input:checked~.showbg.cath {
  --tw-bg-opacity: 1;
  background-color: rgba(113, 63, 18, var(--tw-bg-opacity));
}

label input:checked~.showbg {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
} */

label input:checked~.showcolor-white {
    @apply bg-white text-black
}

/* label input:checked~ .transition-opacity {
  @apply opacity-100
} */


.sale-price-frosted-cookie s {
    @apply mr-2 !font-normal sm:text-xl text-lg
}
</style>

